import { Carousel } from '../../views/ts/components/Carousel';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { FrontPage } from '../twig/pages/front-page';
import { Project } from '../twig/pages/template-projects';
import { Cursor } from './components/Cursor';
(new Carousel()).init();
(new LazyLoader()).init();
(new FrontPage()).init();
(new Project()).init();
(new Cursor()).init();
